import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolencePasswordChange = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [mustChange, setMustChange] = useState(false);

  useEffect(() => {
    fetch('/api/condolence/check', { credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (!data || !data.authenticated) {
          navigate('/condolence');
        } else {
          setMustChange(!!data.must_change);
        }
      })
      .catch(() => navigate('/condolence'));
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('新しいパスワードは8文字以上で入力してください');
      return;
    }
    if (newPassword !== newPasswordConfirm) {
      setError('新しいパスワードが一致しません');
      return;
    }
    if (newPassword === oldPassword) {
      setError('新しいパスワードは現在のパスワードと異なるものを入力してください');
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch('/api/condolence/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/condolence/menu'), 1500);
      } else {
        setError(data.error || 'パスワード変更に失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (mustChange) return;
    navigate('/condolence/menu');
  };

  return (
    <div className="login-page" style={{ background: 'linear-gradient(135deg, #37474f 0%, #263238 100%)' }}>
      <div className="login-container" style={{ maxWidth: '440px' }}>
        <div className="login-title">
          <h1>パスワード変更</h1>
          {mustChange && (
            <p style={{ color: '#ffab91', marginTop: '8px', fontSize: '14px' }}>
              初回ログインのため、パスワードの変更が必要です
            </p>
          )}
        </div>

        {error && <div className="login-error">{error}</div>}
        {success && (
          <div style={{
            background: '#e8f5e9', border: '1px solid #66bb6a', borderRadius: '6px',
            padding: '12px', marginBottom: '16px', color: '#2e7d32', textAlign: 'center'
          }}>
            パスワードを変更しました。メニューに移動します...
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>現在のパスワード</label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              autoFocus
              disabled={success}
            />
          </div>
          <div className="form-group">
            <label>新しいパスワード（8文字以上）</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={success}
            />
          </div>
          <div className="form-group">
            <label>新しいパスワード（確認）</label>
            <input
              type="password"
              value={newPasswordConfirm}
              onChange={(e) => setNewPasswordConfirm(e.target.value)}
              disabled={success}
            />
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={submitting || success}
            style={{ background: '#37474f' }}
          >
            {submitting ? '変更中...' : 'パスワードを変更'}
          </button>
          {!mustChange && (
            <button
              type="button"
              onClick={handleCancel}
              disabled={submitting || success}
              style={{
                width: '100%', marginTop: '12px', padding: '12px',
                background: 'transparent', color: 'white',
                border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              キャンセル
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default CondolencePasswordChange;
